import { render, staticRenderFns } from "./ScanBarcodeFBMModule.vue?vue&type=template&id=04d570c7"
import script from "./ScanBarcodeFBMModule.vue?vue&type=script&lang=js"
export * from "./ScanBarcodeFBMModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports